import { RootState } from "@redux/app/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type UnderConfigurationVesselsList = {
	name: string
	id: number
}[]

const initialState: UnderConfigurationVesselsList = []

const underConfigurationVesselsSlice = createSlice({
	name: "underConfigurationVessels",
	initialState,
	reducers: {
		setUnderConfigurationVessels(state, action: PayloadAction<UnderConfigurationVesselsList>) {
			return action.payload
		},
	},
})

export const getUnderConfigurationVessels = (state: RootState) => state.underConfigurationVessels

export const { setUnderConfigurationVessels } = underConfigurationVesselsSlice.actions

export default underConfigurationVesselsSlice.reducer
